import React from 'react';
import localize from '../localize';
import classnames from 'classnames';
require('./PageHeader.css');

const sections = { h1: 'header', h2: 'subheader', em: 'intro' };

export const PageHeader = (props) => {
  let output = Object.keys(sections).map((tagName) => {
    let key = sections[tagName];
    if(props[key]) {
      let HeaderTag = `${tagName}`;
      return <HeaderTag key={tagName}>{props[key]}</HeaderTag>;
    } else {
      return false;
    }
  });

  const align = props.align === 'left' ? 'left' : 'centered';
  const classes = classnames('pageHeader', 'centered-content', props.className, align);

  return (
    <div className={classes}><header>{output}{props.children}</header></div>
  );
};

export default localize()(({ i18n, ...props }) => {
	let childProps = {...props};

	Object.keys(sections).forEach((tagName) => {
		let key = sections[tagName];
		if(i18n.has(key) && !props[key]) {
			childProps[key] = i18n.t(key);
		}
	});

	return <PageHeader {...childProps} />;
});



// WEBPACK FOOTER //
// ./src/components/PageHeader/index.js